import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput, Margin } from 'shared/components'

import * as style from './styles'

const BeneficiaryFiltersComponent = ({
  form,
  getOptionLabel,
  getOptionValue,
  loadCategories,
  loadSubcategories,
}) => (
  <Form form={form}>
    <Grid>
      <Row middle="xs">
        <Col xs={12} sm={4}>
          <Margin top={1}>
            <FormInput
              name="search"
              icon="search"
              placeholder="Search by beneficiary name..."
              grayBg
            />
          </Margin>
        </Col>
        <Col xs={12} sm={4}>
          <FormInput
            fluid
            isMulti
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="categories"
            placeholder="Categories"
            loadOptions={loadCategories}
            css={style.phoneSpace}
            oldInput
          />
        </Col>
        <Col xs={12} sm={4}>
          <FormInput
            fluid
            isMulti
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="subCategories"
            placeholder="Subcategories"
            loadOptions={loadSubcategories}
            oldInput
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

BeneficiaryFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  loadCategories: PropTypes.func.isRequired,
  loadSubcategories: PropTypes.func.isRequired,
}

export default BeneficiaryFiltersComponent
